import { render, staticRenderFns } from "./synonymList.vue?vue&type=template&id=dd311e0c&scoped=true&"
import script from "./synonymList.vue?vue&type=script&lang=js&"
export * from "./synonymList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd311e0c",
  null
  
)

export default component.exports